<div
  data-at-text
  class="vi-text color-{{ color }} size-{{ size }} weight-{{ weight }}"
>
  <ng-container *ngIf="content">
    <div [innerHTML]="content | viTrustHtml"></div>
  </ng-container>
  <ng-content></ng-content>
</div>
